var $animate = {
  // ======================================================================
  // OPTIONS
  // ======================================================================

  enableIntro: true,

  // ======================================================================
  // VARS
  // ======================================================================

  inited: false,
  isDesktop: false, // stores whether device is at desktop size
  hasIntro: false, // stores whether the current page has an intro
  finishedIntro: false, // stores whether the intro animation has finished
  triggerCount: 0, // stores dynamic trigger id count
  controllers: {}, // stores all scrollmagic controllers
  timelines: {},

  // ======================================================================
  // INIT
  // ======================================================================

  // on page load, initialise animations
  init: function() {
    // changed to wait for first resize event, below
  },

  // re-initialise animations after a page is loaded via AJAX
  reinitAfterAJAX: function() {
    $animate.initPages();
  },

  // re-initialise animations after animating to a new page
  setNewPage: function() {
    $animate.hasIntro = false;
    $animate.destroyPrevPage();
    $animate.initPages();
  },

  // detect browser resizing between mobile and desktop,
  // where animations are different
  resize: function() {
    if ($windowsize.isDesktop != $animate.isDesktop) {
      $animate.isDesktop = $windowsize.isDesktop;
      if (!$animate.inited) {
        $animate.initIntro();
        $animate.initPages();
        $animate.inited = true;
      } else {
        $animate.destroy();
        $animate.initPages();
      }
    }
  },

  // when resizing browser, destroy all existing scrollmagic animations
  destroy: function() {
    // clear and reset controllers
    for (var i in $animate.controllers) {
      var c = $animate.controllers[i];
      c.destroy(true);
    }
    $animate.controllers = {};
    // destroy and reset intro
    $animate.destroyIntro();
    // destroy and reset animated elements
    $animate.destroyDifference();
    $animate.destroyHero();
    $animate.destroyLogos();
    $animate.destroyMedia();
    $animate.destroyNavLogo();
    $animate.destroyTextUp();
    $animate.destroyThumbs();
    $animate.destroyVideos();
    // remove trigger elements
    $('.u-trigger').remove();
  },

  // when changing pages, destroy some global stuff
  destroyPrevPage: function() {
    // $animate.destroyNavLogo();
  },

  // ======================================================================
  // TRIGGERS
  // ======================================================================

  getTriggerId: function() {
    $animate.triggerCount++;
    return $animate.triggerCount;
  },

  getTriggerElement: function(triggerId) {
    return '<div id="trigger-' + triggerId + '" class="u-trigger"></div>';
  },

  // ======================================================================
  // INTRO
  // ======================================================================

  initIntro: function() {
    // if intro config is disabled, skip intro  and enable scrolling instantly
    if (
      !$animate.enableIntro ||
      document.referrer.indexOf('localhost') >= 0 ||
      document.referrer.indexOf('matter.') >= 0 ||
      window.location.hostname === 'localhost' ||
      window.location.hostname === '192.168.0.200'
    ) {
      $('.page__hero--animated').removeClass('page__hero--animated');
      $scroll.enable();
      return;
    }

    // check hero element exists
    var hero = $el('.page--current.page--landing .page__hero.page__hero--animated');
    if (hero.length <= 0) {
      $scroll.enable();
      return;
    } else {
      if ($animate.isDesktop) {
        $animate.initIntroDesktop(hero);
      } else {
        $animate.initIntroMobile(hero);
      }
    }
  },

  initIntroDesktop: function(hero) {
    $animate.hasIntro = true;
    var inner = hero.find('.page__hero-inner');
    var scale = 1.3;
    var delay = 0;
    $animate.timelines.intro = gsap.timeline();
    var t1 = $animate.timelines.intro;
    // fade in
    delay += 0.2;
    t1.fromTo(
      inner,
      {
        scale: scale,
        opacity: 0
      },
      {
        scale: 1,
        opacity: 1,
        duration: 2,
        ease: Power1.easeInOut
      },
      delay
    );
    // resize
    delay += 2.5;
    t1.to(
      inner,
      {
        scale: scale,
        duration: 2,
        ease: Power1.easeInOut
      },
      delay
    );
    t1.to(
      hero,
      {
        width: '65vw',
        duration: 2,
        ease: Power1.easeInOut
      },
      delay
    );
    t1.fromTo(
      $el('#nav'),
      {
        x: '100vw'
      },
      {
        x: '65vw',
        duration: 2,
        ease: Power1.easeInOut
      },
      delay
    );
    // finish
    delay += 2;
    t1.add(function() {
      $animate.finishedIntro = true;
      $scroll.enableAfterIntro();
    }, delay);
  },

  initIntroMobile: function(hero) {
    $animate.hasIntro = true;
    var inner = hero.find('.page__hero-inner');
    var scale = 1.2;
    var delay = 0;
    $animate.timelines.intro = gsap.timeline();
    var t1 = $animate.timelines.intro;
    // fade in
    delay += 0.2;
    t1.fromTo(
      inner,
      {
        scale: scale,
        opacity: 0
      },
      {
        scale: 1,
        opacity: 1,
        duration: 2,
        ease: Power1.easeInOut
      },
      delay
    );
    // finish
    delay += 2;
    t1.add(function() {
      $animate.finishedIntro = true;
      $scroll.enableAfterIntro();
    }, delay);
  },

  // after it has played once, or after changing between mobile and desktop,
  // completely remove intro and any related styles
  destroyIntro: function() {
    try {
      if ($animate.finishedIntro) {
        $animate.timelines.intro.clear().kill();
        $('.page__hero--animated').removeClass('page__hero--animated');
        // enable scrolling
        $scroll.enableAfterIntro();
      }
    } catch (e) {}
    // clear dynamic styles
    var hero = $('.page__hero');
    var inner = hero.find('.page__hero-inner');
    var logo = hero.find('.page__hero-logo');
    hero.attr('style', '');
    inner.attr('style', '');
    logo.attr('style', '');
  },

  // ======================================================================
  // PAGES
  // ======================================================================

  initPages: function() {
    $('#page-' + $pages.currentPage).each(function() {
      var page = $(this);
      var pageId = page.attr('id');

      // check if already inited
      if (typeof $animate.controllers[pageId] !== 'undefined') {
        return;
      }

      // scrollmagic controller
      $animate.controllers[pageId] = new ScrollMagic.Controller(
        $animate.isDesktop
          ? {
              container: '#' + pageId + ' .page__scroll',
              vertical: false
            }
          : {
              container: '#' + pageId + ' .page__scroll'
            }
      );

      // animated elements
      $animate.initDifference(page, pageId);
      $animate.initHero(page, pageId);
      $animate.initLogos(page, pageId);
      $animate.initMedia(page, pageId);
      $animate.initNavLogo(page, pageId);
      $animate.initTextUp(page, pageId);
      $animate.initThumbs(page, pageId);
      $animate.initVideos(page, pageId);
    });
  },

  // ======================================================================
  // ANIMATED ELEMENT - DIFFERENCE MADE
  // ======================================================================

  differenceT1: null,

  initDifference: function(page, pageId) {
    var diffWrap = page.find('.animate-diff');
    if (diffWrap.length > 0) {
      var diffPin1 = diffWrap.find('.animate-diff__pin1');
      var diffMade = diffWrap.find('.animate-diff__made');
      var diffLine = diffWrap.find('.animate-diff__underline');
      var diffStop = diffWrap.find('.animate-diff__stop');

      // triggers
      var triggerId = $animate.getTriggerId();
      var triggerElement = $animate.getTriggerElement(triggerId);
      diffWrap.attr('id', 'ani-' + triggerId);
      $(diffWrap).prepend(triggerElement);

      // timeline
      var t2 = new gsap.timeline();
      t2.fromTo(
        diffPin1,
        0.6,
        {
          xPercent: $animate.isDesktop ? 150 : 80
        },
        {
          xPercent: 0,
          ease: Power1.easeInOut
        }
      );

      // scene
      var s2 = new ScrollMagic.Scene({
        triggerElement: '#trigger-' + triggerId,
        triggerHook: 1,
        duration: $animate.isDesktop ? '60%' : '45%'
      })
        .setTween(t2)
        .reverse(false)
        .addTo($animate.controllers[pageId])
        .on('leave', function(e) {
          if (e.state === 'AFTER') {
            $animate.differenceT1.play();
          }
        });

      // timeline
      try {
        $animate.differenceT1.kill();
      } catch (e) {}
      $animate.differenceT1 = new gsap.timeline({paused: true});
      $animate.differenceT1.fromTo(
        diffMade,
        0.5,
        {
          opacity: 0
        },
        {
          opacity: 1,
          ease: Power1.easeInOut
        },
        0
      );
      // $animate.differenceT1.add(function() {
      //   diffLine.removeClass('u-css-underline-hidden');
      // }, 0.3);
      $animate.differenceT1.fromTo(
        diffStop,
        0.3,
        {
          opacity: 0
        },
        {
          opacity: 1,
          ease: Power1.easeInOut
        },
        0.5
        // 0.8
      );
    }
  },

  destroyDifference: function() {
    $(
      '.animate-diff__pin1, .animate-diff__pin2, .animate-diff__pin2-inner, .animate-diff__difference, .animate-diff__comma, .animate-diff__made, .animate-diff__stop'
    ).css({
      transform: '',
      opacity: ''
    });
    $('.animate-diff__underline').addClass('u-css-underline-hidden');
  },

  // ======================================================================
  // ANIMATED ELEMENT - HERO
  // ======================================================================

  initHero: function(page, pageId) {
    if ($animate.isDesktop) {
      $animate.initHeroDesktop(page, pageId);
    } else {
      $animate.initHeroMobile(page, pageId);
    }
  },

  initHeroDesktop: function(page, pageId) {
    var heroWrap = page.find('.animate-hero');
    if (heroWrap.length == 1) {
      var heroInner = heroWrap.find('.page__hero-inner');
      var heroLogo = heroWrap.find('.page__hero-logo');

      // trigger
      var triggerId = $animate.getTriggerId();
      var triggerElement = $animate.getTriggerElement(triggerId);
      heroWrap.attr('id', 'ani-' + triggerId);
      $(heroWrap).prepend(triggerElement);

      // timeline
      var t1 = new gsap.timeline();
      t1.fromTo(
        heroInner,
        1,
        {
          xPercent: 0
        },
        {
          xPercent: 30,
          ease: Power0.easeNone
        },
        0
      );
      t1.fromTo(
        heroLogo,
        1,
        {
          xPercent: 0
        },
        {
          xPercent: 50,
          ease: Power0.easeNone
        },
        0
      );

      // scene
      var s1 = new ScrollMagic.Scene({
        triggerElement: '#trigger-' + triggerId,
        triggerHook: 0,
        duration: '65%'
      })
        .setTween(t1)
        .reverse(true)
        .addTo($animate.controllers[pageId]);
    }
  },

  initHeroMobile: function(page, pageId) {
    var heroWrap = page.find('.animate-hero');
    if (heroWrap.length == 1) {
      var heroInner = heroWrap.find('.page__hero-inner');

      // trigger
      var triggerId = $animate.getTriggerId();
      var triggerElement = $animate.getTriggerElement(triggerId);
      heroWrap.attr('id', 'ani-' + triggerId);
      $(heroWrap).prepend(triggerElement);

      // timeline
      var t1 = new gsap.timeline();
      t1.fromTo(
        heroInner,
        1,
        {
          yPercent: 0
        },
        {
          yPercent: 30,
          ease: Power0.easeNone
        },
        0
      );

      // scene
      var s1 = new ScrollMagic.Scene({
        triggerElement: '#trigger-' + triggerId,
        triggerHook: 0,
        duration: '100%'
      })
        .setTween(t1)
        .reverse(true)
        .addTo($animate.controllers[pageId]);
      // .on('leave', function(e) {
      //   if (e.state === 'AFTER') {
      //     // hide large intro logo once hero scrolls out of view
      //     $el('body').addClass('js-ani-mob-logo');
      //   }
      // });
    }
  },

  destroyHero: function() {
    // $el('body').removeClass('js-ani-mob-logo');
    $('.page__hero-inner, .page__hero-logo').css({
      transform: ''
    });
  },

  // ======================================================================
  // ANIMATED ELEMENT - LOGOS
  // ======================================================================

  initLogos: function(page, pageId) {
    var logosWrap = page.find('.animate-logos');
    if (logosWrap.length > 0) {
      var logos = logosWrap.find('img');

      // trigger
      var triggerId = $animate.getTriggerId();
      var triggerElement = $animate.getTriggerElement(triggerId);
      logosWrap.attr('id', 'ani-' + triggerId);
      $(logosWrap).prepend(triggerElement);

      // timeline
      var t3 = new gsap.timeline();
      t3.staggerFromTo(
        logos,
        0.7,
        {
          y: 20,
          opacity: 0
        },
        {
          y: 0,
          opacity: 1,
          ease: Power1.easeInOut
        },
        0.1
      );

      // scene
      var s3 = new ScrollMagic.Scene({
        triggerElement: '#trigger-' + triggerId,
        triggerHook: 0.8
      })
        .setTween(t3)
        .reverse(false)
        .addTo($animate.controllers[pageId]);
    }
  },

  destroyLogos: function() {
    $('.animate-logos img').css({
      transform: '',
      opacity: ''
    });
  },

  // ======================================================================
  // ANIMATED ELEMENT - MEDIA
  // ======================================================================

  initMedia: function(page, pageId) {
    if ($animate.isDesktop) {
      $animate.initMediaDesktop(page, pageId);
    } else {
      $animate.initMediaMobile(page, pageId);
    }
  },

  initMediaDesktop: function(page, pageId) {
    var mediaWraps = page.find('.animate-media');
    if (mediaWraps.length > 0) {
      mediaWraps.each(function() {
        var mediaWrap = $(this);
        var mediaParallax = mediaWrap.find('.animate-media__parallax');
        var mediaScale = mediaWrap.find('.animate-media__scale');
        var mediaImage = mediaWrap.find('img');

        // options
        var parallax = typeof mediaWrap.attr('data-parallax') !== 'undefined';
        var depth = typeof mediaWrap.attr('data-depth') !== 'undefined';
        var scale = false; //typeof mediaWrap.attr('data-scale') !== 'undefined';

        // duration
        var imgDuration = 100 + (mediaImage.width() / $windowsize.w) * 100;
        if (imgDuration < 130) {
          imgDuration = 130;
        }

        // trigger
        var triggerId = $animate.getTriggerId();
        var triggerElement = $animate.getTriggerElement(triggerId);
        mediaParallax.attr('id', 'ani-parallax-' + triggerId);
        mediaScale.attr('id', 'ani-scale-' + triggerId);
        mediaImage.attr('id', 'ani-image-' + triggerId);
        $(triggerElement).insertBefore(mediaParallax);

        // parallax + depth
        var t1 = new gsap.timeline();
        if (parallax) {
          var parallaxElement = $('#ani-parallax-' + triggerId);
          var figureParent = $(this).parents('figure');
          if (figureParent.length == 1) {
            var figureCaption = figureParent.find('figcaption');
            if (figureCaption.length == 1) {
              parallaxElement = parallaxElement.add(figureCaption);
            }
          }
          t1.fromTo(
            parallaxElement,
            1,
            {
              x: 100,
              y: 0
            },
            {
              x: -250,
              y: 0,
              ease: Power2.easeIn
            },
            0
          );
        }
        if (depth) {
          t1.fromTo(
            $('#ani-image-' + triggerId),
            1,
            {
              xPercent: -8,
              yPercent: 0
            },
            {
              xPercent: 8,
              yPercent: 0,
              ease: Power0.easeNone
            },
            0
          );
        }
        if (parallax || depth) {
          var s1 = new ScrollMagic.Scene({
            triggerElement: '#trigger-' + triggerId,
            triggerHook: 1,
            duration: imgDuration + '%'
          })
            .setTween(t1)
            .reverse(true)
            .addTo($animate.controllers[pageId]);
        }

        // scale
        // if (scale) {
        //   var t2 = new gsap.timeline();
        //   t2.fromTo(
        //     $('#ani-scale-' + triggerId),
        //     1,
        //     {
        //       scale: 1.03
        //     },
        //     {
        //       scale: 1,
        //       ease: Power1.easeInOut
        //     },
        //     0
        //   );
        //   var s2 = new ScrollMagic.Scene({
        //     triggerElement: '#trigger-' + triggerId,
        //     triggerHook: 0.9
        //   })
        //     .setTween(t2)
        //     .reverse(false)
        //     .addTo($animate.controllers[pageId]);
        // }
      });
    }
  },

  initMediaMobile: function(page, pageId) {
    var mediaWraps = page.find('.animate-media');
    if (mediaWraps.length > 0) {
      mediaWraps.each(function() {
        var mediaWrap = $(this);
        var mediaParallax = mediaWrap.find('.animate-media__parallax');
        var mediaScale = mediaWrap.find('.animate-media__scale');
        var mediaImage = mediaWrap.find('img');

        // options
        var parallax = typeof mediaWrap.attr('data-parallax') !== 'undefined';
        var depth = typeof mediaWrap.attr('data-depth') !== 'undefined';
        var scale = false; //typeof mediaWrap.attr('data-scale') !== 'undefined';

        // duration
        var imgDuration = 100 + (mediaImage.height() / $windowsize.h) * 100;
        if (imgDuration < 140) {
          imgDuration = 140;
        }

        // trigger
        var triggerId = $animate.getTriggerId();
        var triggerElement = $animate.getTriggerElement(triggerId);
        mediaParallax.attr('id', 'ani-parallax-' + triggerId);
        mediaScale.attr('id', 'ani-scale-' + triggerId);
        mediaImage.attr('id', 'ani-image-' + triggerId);
        $(triggerElement).insertBefore(mediaParallax);

        // parallax + depth
        var t1 = new gsap.timeline();
        if (parallax) {
          var parallaxElement = $('#ani-parallax-' + triggerId);
          var figureParent = $(this).parents('figure');
          if (figureParent.length == 1) {
            var figureCaption = figureParent.find('figcaption');
            if (figureCaption.length == 1) {
              parallaxElement = parallaxElement.add(figureCaption);
            }
          }
          t1.fromTo(
            parallaxElement,
            1,
            {
              x: 0,
              y: '8vw'
            },
            {
              x: 0,
              y: '-8vw',
              ease: Power2.easeIn
            },
            0
          );
        }
        if (depth) {
          t1.fromTo(
            $('#ani-image-' + triggerId),
            1,
            {
              xPercent: 0,
              yPercent: -8
            },
            {
              xPercent: 0,
              yPercent: 8,
              ease: Power0.easeNone
            },
            0
          );
        }
        if (parallax || depth) {
          var s1 = new ScrollMagic.Scene({
            triggerElement: '#trigger-' + triggerId,
            triggerHook: 1,
            duration: imgDuration + '%'
          })
            .setTween(t1)
            .reverse(true)
            .addTo($animate.controllers[pageId]);
        }

        // scale
        // if (scale) {
        //   var t2 = new gsap.timeline();
        //   t2.fromTo(
        //     $('#ani-scale-' + triggerId),
        //     1,
        //     {
        //       scale: 1.03
        //     },
        //     {
        //       scale: 1,
        //       ease: Power1.easeInOut
        //     },
        //     0
        //   );
        //   var s2 = new ScrollMagic.Scene({
        //     triggerElement: '#trigger-' + triggerId,
        //     triggerHook: 0.9
        //   })
        //     .setTween(t2)
        //     .reverse(true)
        //     .addTo($animate.controllers[pageId]);
        // }
      });
    }
  },

  destroyMedia: function() {
    $('.animate-media .animate-media__parallax, .animate-media .animate-media__scale, .animate-media img').css({
      transform: ''
    });
  },

  // ======================================================================
  // ANIMATED ELEMENT - NAV LOGO
  // ======================================================================

  initNavLogo: function(page, pageId) {
    if ($animate.isDesktop) {
      $animate.initNavLogoDesktop(page, pageId);
    } else {
      $animate.initNavLogoMobile(page, pageId);
    }
  },

  initNavLogoDesktop: function(page, pageId) {
    if ($animate.hasIntro) {
      var navLogoTrigger = page.find('.page__nav');

      // trigger
      var triggerId = $animate.getTriggerId();
      var triggerElement = $animate.getTriggerElement(triggerId);
      $(navLogoTrigger).prepend(triggerElement);

      // timeline
      var t1 = new gsap.timeline();
      t1.fromTo(
        $el('.nav__logo'),
        1,
        {
          x: 100,
          opacity: 0
        },
        {
          x: 0,
          opacity: 1,
          ease: Power1.easeInOut
        },
        0
      );

      // scene
      var s1 = new ScrollMagic.Scene({
        triggerElement: '#trigger-' + triggerId,
        triggerHook: 0.15
      })
        .setTween(t1)
        .reverse(false)
        .addTo($animate.controllers[pageId]);
    }
  },

  initNavLogoMobile: function(page, pageId) {
    var hero = $el('.page--current.page--landing .page__hero-logo');
    if (hero.length == 1) {
      var navLogoTrigger = page.find('.page__body');

      // trigger
      var triggerId = $animate.getTriggerId();
      var triggerElement = $animate.getTriggerElement(triggerId);
      $(navLogoTrigger).prepend(triggerElement);

      // timeline
      var t1 = new gsap.timeline();
      t1.add(function() {
        $animate.animateNavLogoMobile();
      }, 0.1);

      // scene
      var s1 = new ScrollMagic.Scene({
        triggerElement: '#trigger-' + triggerId,
        triggerHook: 0.3
      })
        .setTween(t1)
        .reverse(false)
        .addTo($animate.controllers[pageId]);
    } else {
      $animate.animateNavLogoMobile();
    }
  },

  animateNavLogoMobile: function() {
    $el('body').addClass('js-ani-mob-logo');
  },

  destroyNavLogo: function() {
    $el('.nav__logo').attr('style', '');
    $el('body').removeClass('js-ani-mob-logo');
  },

  // ======================================================================
  // ANIMATED ELEMENT - TEXT UP
  // ======================================================================

  initTextUp: function(page, pageId) {
    if ($animate.isDesktop) {
      $animate.initTextUpDesktop(page, pageId);
    }
  },

  initTextUpDesktop: function(page, pageId) {
    var textWraps = page.find('.animate-text-up');
    if (textWraps.length > 0) {
      textWraps.each(function() {
        var textWrap = $(this);

        // trigger
        var triggerId = $animate.getTriggerId();
        var triggerElement = $animate.getTriggerElement(triggerId);
        textWrap.attr('id', 'ani-' + triggerId);
        $(textWrap).prepend(triggerElement);

        // timeline
        var t1 = new gsap.timeline();
        t1.fromTo(
          $('#ani-' + triggerId),
          1,
          {
            y: 20,
            opacity: 0
          },
          {
            y: 0,
            opacity: 1,
            ease: Power1.easeInOut
          },
          0
        );

        // scene
        var s1 = new ScrollMagic.Scene({
          triggerElement: '#trigger-' + triggerId,
          triggerHook: 0.8
        })
          .setTween(t1)
          .reverse(false)
          .addTo($animate.controllers[pageId]);
      });
    }
  },

  destroyTextUp: function() {
    $('.animate-text-up').css({
      transform: '',
      opacity: ''
    });
  },

  // ======================================================================
  // ANIMATED ELEMENT - THUMBS
  // ======================================================================

  initThumbs: function(page, pageId) {
    if ($animate.isDesktop) {
      $animate.initThumbsDesktop(page, pageId);
    }
  },

  initThumbsDesktop: function(page, pageId) {
    var thumbs = page.find('.animate-thumb');
    if (thumbs.length > 0) {
      var thumbsTotal = thumbs.length;
      thumbs.each(function() {
        var thumb = $(this);
        var thumbId = parseInt(thumb.attr('data-thumb'));

        // trigger
        var triggerId = $animate.getTriggerId();
        var triggerElement = $animate.getTriggerElement(triggerId);
        thumb.attr('id', 'ani-' + triggerId);
        $(triggerElement).insertBefore(thumb);

        // scene
        var s1 = new ScrollMagic.Scene({
          triggerElement: '#trigger-' + triggerId,
          triggerHook: 0.65,
          duration: '60%'
        })
          .on('start', function(e) {
            if (e.state === 'DURING') {
              $thumbs.scroll(thumbId);
            }
          })
          .on('enter', function(e) {
            if (thumbId === thumbsTotal && $thumbs.current === null) {
              $thumbs.scroll(thumbId);
            }
          })
          .on('leave', function(e) {
            if (e.state === 'BEFORE') {
              if (thumbId === 1) {
                $thumbs.scroll(null);
              } else {
                $thumbs.scroll(thumbId - 1);
              }
            } else if (e.state === 'AFTER' && thumbId === thumbsTotal) {
              $thumbs.scroll(null);
            }
          })
          .addTo($animate.controllers[pageId]);
      });
    }
  },

  destroyThumbs: function() {
    $thumbs.scroll(null);
  },

  // ======================================================================
  // ANIMATED ELEMENT - VIDEOS
  // ======================================================================

  initVideos: function(page, pageId) {
    var videos = page.find('video');
    if (videos.length > 0) {
      videos.each(function() {
        var video = $(this);

        // trigger
        var triggerId = $animate.getTriggerId();
        var triggerElement = $animate.getTriggerElement(triggerId);
        video.attr('id', 'ani-' + triggerId);
        $(triggerElement).insertBefore(video);

        // scene
        var s1 = new ScrollMagic.Scene({
          triggerElement: '#ani-' + triggerId,
          triggerHook: 1,
          duration: '140%'
        })
          .on('start', function(e) {
            if (e.state === 'DURING') {
              $videos.play(video);
            }
          })
          .on('enter', function(e) {
            $videos.play(video);
          })
          .on('leave', function(e) {
            $videos.pause(video);
          })
          .addTo($animate.controllers[pageId]);
      });
    }
  },

  destroyVideos: function() {
    $videos.pauseAll();
  }
};
